import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: {},
    },
    options: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
  },
  watch: {
    chartData() {
      this.$data._chart.update();
      // this.renderChartReport();
    },
  },
  mounted() {
    // this.$data._chart.destroy();
    this.renderChartReport();
  },
  methods: {
    renderChartReport() {
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        // rotation: 1 * Math.PI,
        // circumference: 1 * Math.PI,
        // legend: {
        //   position: "top",
        // },
        title: {
          display: true,
          text: this.title,
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
        height: 450,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              beginAtZero: true,
            },
          ],
        },
      };
      // this.$data._chart.destroy();
      this.renderChart(this.chartData, options);
      // this.$nextTick(() => {
      //   this.$data._chart.update();
      // });
    },
  },
};
